import React from 'react'
import { Document } from './components/document'
import { LearnMore } from './components/learnmore';
import { Video } from './components/video';
import { Split } from './components/split';

interface Props
{
    playgroundRunning : boolean;
}

export class Demo extends React.Component<Props> {

    render() {
        return (
            <>
            <Video src="/videos/1stdemo.mp4"/>

            <div style={{ paddingBottom: "2rem" }} />

            <Split>
                { this.props.playgroundRunning && 
                (<Document>
                    <h2>Want to check it out for your self?</h2>
                    <p>The playground is currently up and running. So you can check out this for your self. Currently everything you do will be stored in the current session, ones you leave the session every thing will be erased.</p>
                    <LearnMore to="/playground">Playground</LearnMore> 
                </Document>)
                }

                <Document>
                    <h2>Want to see more videos?</h2>
                    <p>In this video I'll show you how easy it is to build AI Agents using the tigercity.ai playground.</p>
                    <LearnMore to="/docs/buildingagents">Build Agents</LearnMore> 
                </Document>
            </Split>
            </>
        );
    }
}

